import { render, staticRenderFns } from "./OpenQuestion.vue?vue&type=template&id=3a08d9c6&scoped=true&"
import script from "./OpenQuestion.vue?vue&type=script&lang=js&"
export * from "./OpenQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a08d9c6",
  null
  
)

export default component.exports